import React from 'react'
import { ClipLoader } from 'react-spinners'

const LoadingComponent = () => {
  return (
    <div className="row mt-2">
      <div className="col-12 text-center">
        <div className='sweet-loading'>
          <ClipLoader
            size={75}
            color={'#BF33BD'}
            loading={true}
          />
        </div>
      </div>
    </div>
  )
}

export default LoadingComponent
